import React, { useState } from 'react';
import { FaTimes, FaPhoneAlt, FaEnvelope, FaUser, FaCity, FaCommentAlt, FaCheckCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useLanguage } from '../../i18n';
import { submitLead, CONTACT_PHONE } from '../../utils/leads';
import './style.scss';

const LeadPopup = ({ isOpen, onClose }) => {
    const { language } = useLanguage();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        city: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.phone) {
            return;
        }

        setLoading(true);

        try {
            await submitLead(formData, 'Free consultation popup');
            setSubmitted(true);
        } catch (error) {
            console.error('Lead submission failed:', error);
            toast.error(language === 'hi'
                ? `जानकारी नहीं भेजी जा सकी। कृपया हमें ${CONTACT_PHONE} पर कॉल करें।`
                : `Couldn't send your details. Please call us on ${CONTACT_PHONE}.`);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        sessionStorage.setItem('leadPopupClosed', 'true');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="leadPopupOverlay" onClick={handleClose}>
            <div className="leadPopupModal" onClick={(e) => e.stopPropagation()}>
                <button className="closeBtn" onClick={handleClose} aria-label="Close">
                    <FaTimes />
                </button>

                {submitted ? (
                    <div className="successMessage">
                        <div className="successIcon">
                            <FaCheckCircle />
                        </div>
                        <h2>
                            {language === 'hi'
                                ? 'धन्यवाद!'
                                : 'Thank You!'}
                        </h2>
                        <p>
                            {language === 'hi'
                                ? 'आपकी जानकारी सफलतापूर्वक प्राप्त हो गई है। हमारी टीम जल्द ही आपसे संपर्क करेगी।'
                                : 'Your information has been received successfully. Our team will connect with you soon.'}
                        </p>
                        <button className="closeSuccessBtn" onClick={handleClose}>
                            {language === 'hi' ? 'ठीक है' : 'OK'}
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="popupHeader">
                            <span className="badge">
                                {language === 'hi' ? 'निःशुल्क परामर्श' : 'Free Consultation'}
                            </span>
                            <h2>
                                {language === 'hi'
                                    ? 'अपना निःशुल्क कानूनी परामर्श प्राप्त करें!'
                                    : 'Get Your Free Legal Consultation!'}
                            </h2>
                            <p>
                                {language === 'hi'
                                    ? 'अपना विवरण भरें और हमारे विशेषज्ञ वकील 24 घंटे के भीतर आपसे संपर्क करेंगे।'
                                    : 'Fill in your details and our expert lawyers will contact you within 24 hours.'}
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="popupForm">
                            <div className="inputGroup">
                                <FaUser className="icon" />
                                <input
                                    type="text"
                                    name="name"
                                    placeholder={language === 'hi' ? 'आपका नाम *' : 'Your Name *'}
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="inputGroup">
                                <FaPhoneAlt className="icon" />
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder={language === 'hi' ? 'फोन नंबर *' : 'Phone Number *'}
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="inputGroup">
                                <FaEnvelope className="icon" />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder={language === 'hi' ? 'ईमेल (वैकल्पिक)' : 'Email (Optional)'}
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="inputGroup">
                                <FaCity className="icon" />
                                <input
                                    type="text"
                                    name="city"
                                    placeholder={language === 'hi' ? 'शहर' : 'City'}
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="inputGroup">
                                <FaCommentAlt className="icon" />
                                <textarea
                                    name="message"
                                    placeholder={language === 'hi' ? 'संक्षेप में अपना मामला बताएं' : 'Briefly describe your case'}
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="3"
                                />
                            </div>

                            <button type="submit" className="submitBtn" disabled={loading}>
                                {loading
                                    ? (language === 'hi' ? 'भेज रहा है...' : 'Sending...')
                                    : (language === 'hi' ? 'निःशुल्क परामर्श बुक करें' : 'Book Free Consultation')}
                            </button>

                            <p className="disclaimer">
                                {language === 'hi'
                                    ? '🔒 आपकी जानकारी 100% सुरक्षित और गोपनीय है'
                                    : '🔒 Your information is 100% secure and confidential'}
                            </p>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default LeadPopup;
